// Central data for Vardaan Arts product categories
// Uses user-provided images for Indoor/Outdoor temples;
// carefully-picked reference images for the remaining categories

export const BRAND = {
  name: "Vardaan Arts",
  tagline: "Crafting Divine Beauty in Marble",
  owner: "Yogesh R. Varma",
  phone: "+917777059912",
  phoneDisplay: "+91 77770 59912",
  whatsapp: "917777059912",
  factoryPhone: "+919414262780",
  factoryPhoneDisplay: "+91 94142 62780",
  factoryWhatsapp: "919414262780",
  email: "vardaanarts9@gmail.com",
  established: 2014,
  material: "Makrana White Marble — Grade 1 Sangmarmar",
  address:
    "Western Express Highway, Near Fountain Hotel, Ghodbander Road Signal, Near Versova Jain Temple, Thane, Maharashtra - 401104",
  factoryAddress:
    "Near Samrat School, Matabar Road, Makrana, Rajasthan - 341505",
  addressShort: "Thane, Maharashtra, India",
  logo:
    "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/yhpq56vr_ChatGPT%20Image%20Aug%204%2C%202026%2C%2003_26_58%20PM.png",
  instagram: "https://www.instagram.com/vardaan.arts",
};

export const CATEGORIES = [
  { id: "all", label: "All Collections" },
  { id: "indoor", label: "Indoor Temples" },
  { id: "outdoor", label: "Outdoor Temples" },
  { id: "statues", label: "Statues" },
  { id: "fountain", label: "Fountains" },
  { id: "wall-panel", label: "Wall Panels" },
  { id: "showpiece", label: "Showpieces" },
  { id: "inlay", label: "Inlay Work Art" },
  { id: "wash-basin", label: "Wash Basins" },
  { id: "animals", label: "Elephants & Lions" },
  { id: "table-top", label: "Table Tops" },
  { id: "modern", label: "Modern Art" },
  { id: "roman", label: "Roman Art & Sculpture" },
  { id: "urli", label: "Marble Urlis" },
  { id: "jali", label: "Jali Work" },
  { id: "flower-pot", label: "Flower Pots" },
  { id: "tulsi", label: "Tulsi Vrindavan" },
];

export const PRODUCTS = [
  // Indoor Temples (user-supplied)
  {
    id: "in-1",
    category: "indoor",
    title: "Arched Sanctum Temple",
    description:
      "Hand-carved arch with lattice work, twin columns and delicate floral bands in Makrana white marble.",
    image:
      "/products/wm-in-1.jpg",
  },
  {
    id: "in-2",
    category: "indoor",
    title: "Twin-Dome Om Mandir",
    description:
      "Elegant twin-dome design with a carved Om center and floral cornice — a serene home altar.",
    image:
      "/products/wm-in-2.jpg",
  },
  {
    id: "in-3",
    category: "indoor",
    title: "Peacock Kalash Temple",
    description:
      "Grand hand-carved arch with intricate peacock feather inlay and turned columns.",
    image:
      "/products/wm-in-3.jpg",
  },
  {
    id: "in-4",
    category: "indoor",
    title: "Grand Peacock Inlay Mandir",
    description:
      "Statement piece with brilliant blue peacock inlay in semi-precious stone against ivory Makrana marble.",
    image:
      "/products/wm-in-4.jpg",
  },
  {
    id: "in-5",
    category: "indoor",
    title: "Domed Lotus Sanctum",
    description:
      "Central dome, floral inlay panels and marble lotus stands — pure temple architecture indoors.",
    image:
      "/products/wm-in-5.jpg",
  },
  {
    id: "in-6",
    category: "indoor",
    title: "Ornate Crown Temple with Floral Base",
    description:
      "Statement indoor mandir with an elaborate carved crown, cherub finials and hand-carved floral rosette panels — a majestic Makrana white marble home temple.",
    image:
      "/products/wm-in-6.jpg",
  },
  {
    id: "in-7",
    category: "indoor",
    title: "Peacock Halo Mandir with Elephant Base",
    description:
      "Grand indoor temple with a peacock-feather semi-precious stone halo, tall carved arches, elephant guardians and a stepped pedestal — museum-grade craftsmanship.",
    image:
      "/products/wm-in-7.jpg",
  },
  {
    id: "in-8",
    category: "indoor",
    title: "Five-Shikhar Multi-Dome Indoor Mandir",
    description:
      "Five-dome multi-shikhar indoor temple with intricately carved peacock pillars and floral cornice — an heirloom Makrana marble installation.",
    image:
      "/products/wm-in-8.jpg",
  },
  {
    id: "in-9",
    category: "indoor",
    title: "Navgrah Mandir with Tree of Life",
    description:
      "Compact indoor temple featuring a Navgrah frieze on top, tree-of-life relief inside and elephant procession base panel — pure Makrana white marble.",
    image:
      "/products/wm-in-9.jpg",
  },
  {
    id: "in-10",
    category: "indoor",
    title: "Elegant Arched Column Mandir",
    description:
      "Refined indoor mandir with a filigree carved arch, turned marble columns and dedicated pedestal — a timeless pooja room design.",
    image:
      "/products/wm-in-10.jpg",
  },

  {
    id: "in-11",
    category: "indoor",
    title: "Gilded Cabinet Mandir",
    description:
      "Carved from a single Makrana white marble Grade 1 sangmarmar block — arched sanctum with fluted pillars resting on a gold geometric-jaali cabinet base.",
    image:
      "/products/wm-in-11.jpg",
  },
  {
    id: "in-12",
    category: "indoor",
    title: "Tri-Shikhar Jali Mandir",
    description:
      "Three-shikhar indoor temple carved from a Makrana Grade 1 sangmarmar block — full jali lattice walls, red floral inlay frieze and elephant guardians.",
    image:
      "/products/wm-in-12.jpg",
  },
  {
    id: "in-13",
    category: "indoor",
    title: "Peacock Pillar Golden Mandir",
    description:
      "Ornate Makrana white marble Grade 1 sangmarmar temple with hand-gilded peacock pillars, ashtamangal frieze and a sculpted peacock pedestal base.",
    image:
      "/products/wm-in-13.jpg",
  },
  {
    id: "in-14",
    category: "indoor",
    title: "Royal Torana Backdrop Mandir",
    description:
      "Grand torana-arch backdrop temple carved from a single Makrana Grade 1 sangmarmar block — gold vine inlay panel, shell-finial crests and elephant pillars.",
    image:
      "/products/wm-in-14.jpg",
  },
  {
    id: "in-15",
    category: "indoor",
    title: "Peacock Arch Niche Mandir",
    description:
      "Wall-niche temple in Makrana white marble Grade 1 sangmarmar — peacock-crest arch, fluted columns, elephant bases and a lotus-carved cabinet.",
    image:
      "/products/wm-in-15.jpg",
  },

  {
    id: "in-16",
    category: "indoor",
    title: "Jain Temple Parikar — Grand Toran with Simha Peeth",
    description:
      "Ornate Jain temple parikar with a sculpted toran arch and lion-deity pedestal base — hand-carved in Makrana white marble Grade 1 sangmarmar.",
    image: "/products/wm-in-16.jpg",
  },
  {
    id: "in-17",
    category: "indoor",
    title: "Jain Temple Parikar — Gaja Toran",
    description:
      "Round-crest Jain parikar with elephant toran and finely carved devta pillars — pure Makrana white marble Grade 1 sangmarmar.",
    image: "/products/wm-in-17.jpg",
  },
  {
    id: "in-18",
    category: "indoor",
    title: "Jain Temple Parikar — Devta Panel",
    description:
      "Wide Jain temple parikar with celestial devta figures and delicate openwork scrolls — Makrana white marble Grade 1 sangmarmar.",
    image: "/products/wm-in-18.jpg",
  },
  {
    id: "in-19",
    category: "indoor",
    title: "Peacock Om Pooja Room (Full Wall)",
    description:
      "Complete pooja-room transformation — peacock-feather Om backdrop with swastik medallions and ashtamangal cabinet base, carved in Makrana white marble.",
    image: "/products/wm-in-19.jpg",
  },
  {
    id: "in-20",
    category: "indoor",
    title: "Mayur Toran Mandir (Hand-Painted)",
    description:
      "Peacock-crest toran temple with hand-painted gold-green peacocks, elephant pillar bases and carved storage drawers — Makrana white marble.",
    image: "/products/wm-in-20.jpg",
  },
  {
    id: "in-21",
    category: "indoor",
    title: "Double-Arch Jali Mandir",
    description:
      "Layered double-arch temple with full jali side walls resting on a carved multi-drawer cabinet — pure Makrana white marble.",
    image: "/products/wm-in-21.jpg",
  },
  {
    id: "in-22",
    category: "indoor",
    title: "Grand Tiered-Step Mandir",
    description:
      "Palace-style centrepiece with concentric tiered steps, twin side shrines and a carved ceiling canopy — sculpted in Makrana white marble.",
    image: "/products/wm-in-22.jpg",
  },
  {
    id: "in-23",
    category: "indoor",
    title: "Rajwada Hanging-Finial Mandir",
    description:
      "Tall carved temple with hanging finials, twin-elephant crest and a sculpted procession base — pure Makrana white marble.",
    image: "/products/wm-in-23.jpg",
  },
  {
    id: "in-24",
    category: "indoor",
    title: "Wall-Mounted Jharokha Mandir",
    description:
      "Floating wall-mounted jharokha with layered carved arch and corbelled base — an elephant-accented Makrana marble temple for compact spaces.",
    image: "/products/wm-in-24.jpg",
  },
  {
    id: "in-25",
    category: "indoor",
    title: "Tri-Arch Niche Mandir",
    description:
      "Wall-niche temple with triple carved arches, three shikhars and fluted pillars — a serene all-white Makrana marble design.",
    image: "/products/wm-in-25.jpg",
  },
  {
    id: "in-26",
    category: "indoor",
    title: "Backlit Jali Pooja Ghar",
    description:
      "Grand jali backdrop temple with warm backlighting, curved stepped platform and carved cabinet base — shown installed in a client's home.",
    image: "/products/wm-in-26.jpg",
  },
  {
    id: "in-27",
    category: "indoor",
    title: "Tri-Shikhar Om Jali Mandir",
    description:
      "Three-shikhar temple with fine jali lattice walls and a carved Om medallion — shown installed at a client site.",
    image: "/products/wm-in-27.jpg",
  },
  {
    id: "in-28",
    category: "indoor",
    title: "Peacock Pillar Dev-Sthali",
    description:
      "Grand multi-shelf temple with full peacock pillars, triple domes and carved deity shelves — a complete dev-sthali in Makrana white marble.",
    image: "/products/wm-in-28.jpg",
  },
  {
    id: "in-29",
    category: "indoor",
    title: "Mahal Toran Cabinet Mandir",
    description:
      "Grand four-pillar toran temple on a floral-carved cabinet base with a temple-crest skyline — pure Makrana white marble.",
    image: "/products/wm-in-29.jpg",
  },
  {
    id: "in-30",
    category: "indoor",
    title: "Kalpavriksha Arch Backdrop Mandir",
    description:
      "Tree-of-life (Kalpavriksha) carved arch backdrop with a tiered step platform — a full-wall pooja installation in Makrana marble.",
    image: "/products/wm-in-30.jpg",
  },
  {
    id: "in-31",
    category: "indoor",
    title: "Mahavir Swami Kalpavriksha Sthapana",
    description:
      "Jain sthapana with seated Mahavir Swami before a sculpted floral tree backdrop and chakra medallion — Makrana white marble.",
    image: "/products/wm-in-31.jpg",
  },
  {
    id: "in-32",
    category: "indoor",
    title: "Kalpavriksha Simha-Gaja Peeth Mandir",
    description:
      "Tree-of-life backdrop rising over a three-tier peeth carved with lion and elephant guardians — pure Makrana white marble.",
    image: "/products/wm-in-32.jpg",
  },
  {
    id: "in-33",
    category: "indoor",
    title: "Om-Swastik Triple Shrine Mandir",
    description:
      "Grand triple-shrine temple with Om and swastik medallions, serpent-scroll crown and stepped platform — Makrana white marble.",
    image: "/products/wm-in-33.jpg",
  },

  // Outdoor Temples (user-supplied)
  {
    id: "out-1",
    category: "outdoor",
    title: "Pink Sandstone Garden Shikhar",
    description:
      "Classical pink sandstone temple with tiered shikhar and traditional carved pillars — heritage architecture for open landscapes.",
    image:
      "/products/wm-out-1.jpg",
  },
  {
    id: "out-2",
    category: "outdoor",
    title: "Grand Somnath-Style Mandir",
    description:
      "Full-scale traditional shikhar temple in Makrana white marble — built to order for communities, trusts and large estates.",
    image:
      "/products/wm-out-2.jpg",
  },
  {
    id: "out-3",
    category: "outdoor",
    title: "Elephant Guardian Mandir",
    description:
      "Makrana white marble outdoor temple flanked by carved elephant guardians and a golden gilded door.",
    image:
      "/products/wm-out-3.jpg",
  },
  {
    id: "out-4",
    category: "outdoor",
    title: "Multi-Shikhar Marble Mandap",
    description:
      "Five-shikhar Jain-style mandap in Makrana white marble with narrative frieze base panels and turned balustrade.",
    image:
      "/products/wm-out-4.jpg",
  },
  {
    id: "out-5",
    category: "outdoor",
    title: "Garden Mandap Temple",
    description:
      "Compact Makrana white marble outdoor mandap with lattice jaali walls and stepped roof — a peaceful garden shrine.",
    image:
      "/products/wm-out-5.jpg",
  },

  {
    id: "out-6",
    category: "outdoor",
    title: "Terrace Shikhar Mandir",
    description:
      "Makrana white marble outdoor temple with carved shikhar, scalloped-arch doorway and matching marble railing — installed on a rooftop terrace.",
    image:
      "/products/wm-out-6.jpg",
  },
  {
    id: "out-7",
    category: "outdoor",
    title: "Sandstone Porch Mandir",
    description:
      "Pink sandstone outdoor temple with multi-shikhar roof, columned entrance porch and jali side walls — a flag-topped heritage installation for gardens and ashrams.",
    image:
      "/products/wm-out-7.jpg",
  },
  {
    id: "out-8",
    category: "outdoor",
    title: "Twin-Shikhar Marble Mandap",
    description:
      "Compact Makrana white marble outdoor mandap with twin shikhars, scalloped arches and carved pillars — ideal for courtyards and village temples.",
    image:
      "/products/wm-out-8.jpg",
  },

  // Statues (user-supplied)
  {
    id: "st-1",
    category: "statues",
    title: "Maa Saraswati",
    description:
      "Goddess Saraswati playing the veena, seated on swan vahana — pure white Makrana Grade 1 marble.",
    image:
      "/products/wm-st-1.jpg",
  },
  {
    id: "st-2",
    category: "statues",
    title: "Maa Durga on Simha",
    description:
      "Majestic 3-feet Durga Maa seated on lion vahana — pure white Makrana marble finish.",
    image:
      "/products/wm-st-2.jpg",
  },
  {
    id: "st-3",
    category: "statues",
    title: "Sanjeevani Hanuman",
    description:
      "Standing Hanuman Ji carrying the Sanjeevani parvat with gada — a symbol of strength, in Makrana marble.",
    image:
      "/products/wm-st-3.jpg",
  },
  {
    id: "st-4",
    category: "statues",
    title: "Ram Darbar Trio",
    description:
      "Shri Ram, Laxman & Bharat marble idols with traditional colouring and gold-tone crowns.",
    image:
      "/products/wm-st-4.jpg",
  },
  {
    id: "st-5",
    category: "statues",
    title: "Shri Hanuman Ji (Painted)",
    description:
      "Hand-carved seated Hanuman Ji with fine painted detailing, crown, gada and mala — Makrana Grade 1 marble.",
    image:
      "/products/wm-st-5.jpg",
  },
  {
    id: "st-6",
    category: "statues",
    title: "Lord Vishnu Standing Murti",
    description:
      "Four-armed Lord Vishnu standing on a lotus pedestal with shankha, chakra and gada — hand-carved from pure Makrana white marble.",
    image:
      "/products/wm-st-6.jpg",
  },
  {
    id: "st-7",
    category: "statues",
    title: "Shri Ram & Vishnu Dev Pair",
    description:
      "Standing Shri Ram with dhanush alongside four-armed Lord Vishnu holding shankha-chakra — a divine pair in Makrana white marble.",
    image:
      "/products/wm-st-7.jpg",
  },
  {
    id: "st-8",
    category: "statues",
    title: "Grand Vitarka Buddha",
    description:
      "Large serene Buddha in vitarka mudra seated on a double-lotus pedestal — sculpted at our Makrana workshop in pure white marble.",
    image:
      "/products/wm-st-8.jpg",
  },
  {
    id: "st-9",
    category: "statues",
    title: "Abhaya Mudra Buddha",
    description:
      "Mirror-polished Makrana marble Buddha in abhaya mudra with flame ushnisha and lotus base — a calming presence for any space.",
    image:
      "/products/wm-st-9.jpg",
  },
  {
    id: "st-10",
    category: "statues",
    title: "Kamadhenu Cow & Calf",
    description:
      "Sacred Kamadhenu gau mata feeding her calf — an auspicious Vastu sculpture carved from pure white Makrana marble.",
    image:
      "/products/wm-st-10.jpg",
  },
  {
    id: "st-11",
    category: "statues",
    title: "Mahavir Hanuman (Seated)",
    description:
      "Seated Hanuman Ji in blessing mudra with ornate crown and gada, finished with hand-painted gold accents on Makrana marble.",
    image:
      "/products/wm-st-11.jpg",
  },
  {
    id: "st-12",
    category: "statues",
    title: "Maa Lakshmi (Gold Finish)",
    description:
      "Four-armed Maa Lakshmi seated on a lotus with owl vahana, gold-painted ornaments and pink lotus buds — pure Makrana marble.",
    image:
      "/products/wm-st-12.jpg",
  },
  {
    id: "st-13",
    category: "statues",
    title: "Maa Saraswati with Veena (Gold Finish)",
    description:
      "Maa Saraswati playing the veena with hansa vahana at her feet, hand-painted gold detailing on pure Makrana white marble.",
    image:
      "/products/wm-st-13.jpg",
  },
  {
    id: "st-14",
    category: "statues",
    title: "Shree Ganesh (Gold Finish)",
    description:
      "Chaturbhuja Ganesh Ji seated on a lotus with modak and mushak, adorned with gold-painted crown and jewellery — Makrana marble.",
    image:
      "/products/wm-st-14.jpg",
  },
  {
    id: "st-15",
    category: "statues",
    title: "Dancing Apsara Trio",
    description:
      "Set of three graceful dancing apsara figures in classical poses — hand-carved temple dancers in pure Makrana white marble.",
    image:
      "/products/wm-st-15.jpg",
  },
  {
    id: "st-16",
    category: "statues",
    title: "Maharaja Ganesh (Grand Seated)",
    description:
      "Grand four-armed Ganesh Ji in royal seated pose with ornate carved crown, kalash and chakra — pure Makrana white marble.",
    image: "/products/wm-st-16.jpg",
  },
  {
    id: "st-17",
    category: "statues",
    title: "Shree Ganesh (Gold Ornament Finish)",
    description:
      "Seated Ganesh Ji with hand-painted gold crown, jewellery and base detailing on pure Makrana white marble.",
    image: "/products/wm-st-17.jpg",
  },
  {
    id: "st-18",
    category: "statues",
    title: "Classic White Seated Ganesh",
    description:
      "Traditional seated Ganesh Ji with modak and mushak vahana at his feet — timeless pure white Makrana marble finish.",
    image: "/products/wm-st-18.jpg",
  },
  {
    id: "st-19",
    category: "statues",
    title: "Murlidhar Krishna (Full Colour)",
    description:
      "Standing Krishna playing the flute, hand-painted in vibrant colours with gold crown and peacock feather — Makrana marble.",
    image: "/products/wm-st-19.jpg",
  },
  {
    id: "st-20",
    category: "statues",
    title: "Murlidhar Krishna (Gold & Ivory)",
    description:
      "Standing flute-playing Krishna with elegant gold-and-ivory hand painting on pure Makrana white marble.",
    image: "/products/wm-st-20.jpg",
  },

  // Fountains (user-supplied)
  {
    id: "ft-1",
    category: "fountain",
    title: "White Marble Tiered Fountain",
    description:
      "Hand-carved three-tier fountain in Makrana white marble — an elegant centrepiece for courtyards, gardens and entrances.",
    image:
      "/products/wm-ft-1.jpg",
  },
  {
    id: "ft-2",
    category: "fountain",
    title: "Sandstone Kalash Fountain",
    description:
      "Traditional sandstone tiered fountain with kalash finial — warm heritage tones for open outdoor settings.",
    image:
      "/products/wm-ft-2.jpg",
  },
  {
    id: "ft-3",
    category: "fountain",
    title: "Sandstone Stepped Water Feature",
    description:
      "Contemporary sandstone stepped water feature with cascading bowls — perfect for gardens and hotel lobbies.",
    image:
      "/products/wm-ft-3.jpg",
  },
  {
    id: "ft-4",
    category: "fountain",
    title: "Lotus Petal Tiered Fountain",
    description:
      "Elegant two-tier lotus-petal fountain hand-carved from Makrana white marble with a kalash finial and lotus base.",
    image:
      "/products/wm-ft-4.jpg",
  },
  {
    id: "ft-5",
    category: "fountain",
    title: "Marble Rose Bloom Water Feature",
    description:
      "Hexagonal Makrana white marble water feature with carved floral bands and a sculpted rose bloom centrepiece.",
    image:
      "/products/wm-ft-5.jpg",
  },
  {
    id: "ft-6",
    category: "fountain",
    title: "Rustic Matka & Turtle Fountain",
    description:
      "Playful rustic sandstone fountain with tilted matkas, mushroom stools and carved turtles — perfect for gardens and villas.",
    image:
      "/products/wm-ft-6.jpg",
  },
  {
    id: "ft-7",
    category: "fountain",
    title: "Modern Sandstone Cascade Fountain",
    description:
      "Contemporary sandstone cascade fountain with clean minimal bowls stacked over a monolithic base — bold outdoor sculpture.",
    image:
      "/products/wm-ft-7.jpg",
  },
  // Wall Panels (user-supplied)
  {
    id: "wp-1",
    category: "wall-panel",
    title: "Custom Portrait Relief Panel",
    description:
      "Personalised marble portrait wall panel — commission your loved ones' likeness sculpted from a single Makrana white marble block.",
    image:
      "/products/wm-wp-1.jpg",
  },
  {
    id: "wp-2",
    category: "wall-panel",
    title: "Krishna-Arjuna Rath Panel",
    description:
      "Hand-carved Mahabharat rath scene — Krishna guiding Arjuna's chariot — sculpted from Makrana white marble.",
    image:
      "/products/wm-wp-2.jpg",
  },
  {
    id: "wp-3",
    category: "wall-panel",
    title: "Sandstone Tree of Life Panel",
    description:
      "Grand sandstone tree of life wall panel with lush foliage, gnarled branches and carved birds — a stunning statement wall.",
    image:
      "/products/wm-wp-3.jpg",
  },
  {
    id: "wp-4",
    category: "wall-panel",
    title: "Kalpavriksha with Kamadhenu",
    description:
      "White marble Kalpavriksha wall relief with gilded flowers, songbirds and Kamadhenu cows at the base — a devotional feature wall.",
    image:
      "/products/wm-wp-4.jpg",
  },
  {
    id: "wp-5",
    category: "wall-panel",
    title: "Dense Sandstone Tree Panel",
    description:
      "Intricate sandstone tree of life relief with dense branch work, carved birds and root detailing — ideal for entryways and lobbies.",
    image:
      "/products/wm-wp-5.jpg",
  },
  {
    id: "wp-6",
    category: "wall-panel",
    title: "Framed Ganesha Relief Panel",
    description:
      "Divine Ganesha Ji in an ornate prabhavali frame — 3D relief wall panel installed with spotlighting for a grand devotional feature wall.",
    image:
      "/products/wm-wp-6.jpg",
  },
  {
    id: "wp-7",
    category: "wall-panel",
    title: "Buddha Leaf Face Panel",
    description:
      "Serene Buddha face emerging from sculpted leaves — a zen white marble wall relief for meditation corners, spas and living rooms.",
    image:
      "/products/wm-wp-7.jpg",
  },
  {
    id: "wp-8",
    category: "wall-panel",
    title: "Seven Running Horses Panel",
    description:
      "Auspicious Vastu seven-horse panel with mountains, rising sun and flowering tree — carved in warm golden sandstone.",
    image:
      "/products/wm-wp-8.jpg",
  },
  {
    id: "wp-9",
    category: "wall-panel",
    title: "Blooming Lotus Sandstone Panel",
    description:
      "Stylised blooming lotus with seed pods and flowing petals — hand-carved golden sandstone wall art for entrances and lobbies.",
    image:
      "/products/wm-wp-9.jpg",
  },
  {
    id: "wp-10",
    category: "wall-panel",
    title: "Geeta Updesh Rath Panel (3ft × 4ft)",
    description:
      "Bhagwan Krishna guiding Arjun on the four-horse chariot — a custom 3ft × 4ft deep-relief wall panel carved from a 30mm Makrana white marble Grade 1 sangmarmar block.",
    image:
      "/products/wm-wp-10.jpg",
  },
  {
    id: "wp-11",
    category: "wall-panel",
    title: "Sheshshayi Vishnu-Lakshmi Panel (4ft × 3ft)",
    description:
      "Lord Vishnu resting on Sheshnag with Maa Lakshmi — a custom 4ft × 3ft deep-relief wall panel carved from a 1.5-inch Makrana white marble Grade 1 block (CNC + hand carving).",
    image:
      "/products/wm-wp-11.jpg",
  },

  // Showpieces (user-supplied)
  {
    id: "sp-1",
    category: "showpiece",
    title: "Green Marble Twin Urns",
    description:
      "Pair of hand-carved green marble urn showpieces with fluted bowls and pedestal bases — statement centrepieces for foyers and gardens.",
    image:
      "/products/wm-sp-1.jpg",
  },
  {
    id: "sp-2",
    category: "showpiece",
    title: "Serene Buddha Head",
    description:
      "Meditative Buddha head sculpted in polished Makrana white marble — a calming presence for any space.",
    image:
      "/products/wm-sp-2.jpg",
  },
  {
    id: "sp-3",
    category: "showpiece",
    title: "Divine Embrace Sculpture",
    description:
      "Contemporary Makrana marble sculpture of a tender embrace with a nested face — an artistic devotional showpiece.",
    image:
      "/products/wm-sp-3.jpg",
  },
  {
    id: "sp-4",
    category: "showpiece",
    title: "Contemplative Black Buddha",
    description:
      "Black marble reclining Buddha head with meditating figure and stacked stone base — a museum-grade showpiece.",
    image:
      "/products/wm-sp-4.jpg",
  },
  {
    id: "sp-5",
    category: "showpiece",
    title: "The Pull (Black Marble)",
    description:
      "A lone figure pulling a sphere with a rope over angular forms — a powerful modern showpiece in polished black marble.",
    image:
      "/products/wm-sp-5.jpg",
  },
  {
    id: "il-1",
    category: "inlay",
    title: "Mandala Inlay Table Top",
    description:
      "Round mother-of-pearl inlay with dark floral rosettes — mesmerising handcrafted mandala pattern.",
    image:
      "/products/wm-il-1.jpg",
  },
  {
    id: "il-2",
    category: "inlay",
    title: "Peacock Feather Inlay",
    description:
      "Iridescent abalone and gems stone peacock feather inlay — a signature Vardaan Arts artwork.",
    image:
      "/products/wm-il-2.jpg",
  },
  {
    id: "il-3",
    category: "inlay",
    title: "Twin Peacock Wall Doors",
    description:
      "Full-height twin peacock inlay wall panels in mother-of-pearl and semi-precious stones.",
    image:
      "/products/wm-il-3.jpg",
  },
  {
    id: "il-4",
    category: "inlay",
    title: "Mother-of-Pearl Dining Top",
    description:
      "Radiating mother-of-pearl dining table top with concentric gem inlay medallion.",
    image:
      "/products/wm-il-4.jpg",
  },
  {
    id: "il-5",
    category: "inlay",
    title: "Royal Tiger Inlay",
    description:
      "Bold tiger figure crafted in mother-of-pearl on black marble — museum-grade artistry.",
    image:
      "/products/wm-il-5.jpg",
  },
  // Wash Basins (user-supplied)
  {
    id: "wb-1",
    category: "wash-basin",
    title: "White Marble Pedestal Basin",
    description:
      "Tapered pedestal wash basin carved from a single block of Makrana white marble with natural veining — a sculptural bathroom centrepiece.",
    image:
      "/products/wm-wb-1.jpg",
  },
  {
    id: "wb-2",
    category: "wash-basin",
    title: "Black Marble Chalice Basin",
    description:
      "Elegant goblet-shaped pedestal basin in polished black marble — a bold monolithic statement for luxury washrooms.",
    image:
      "/products/wm-wb-2.jpg",
  },
  {
    id: "wb-3",
    category: "wash-basin",
    title: "Banded Black Textured Basin",
    description:
      "Tall black pedestal wash basin with contrasting grey textured bands — modern craftsmanship in solid marble.",
    image:
      "/products/wm-wb-3.jpg",
  },
  {
    id: "wb-4",
    category: "wash-basin",
    title: "Striped Marble Pedestal with Copper Rim",
    description:
      "Signature black-and-white striped pedestal basin with a warm copper-toned rim — bold, artistic and one-of-a-kind.",
    image:
      "/products/wm-wb-4.jpg",
  },
  // Elephants & Lions (user-supplied)
  {
    id: "an-1",
    category: "animals",
    title: "Ceremonial Marble Elephants",
    description:
      "Pair of white Makrana marble elephants with intricately carved ceremonial coverings, ornaments and pedestal — ideal outdoor gateway guardians.",
    image:
      "/products/wm-an-1.jpg",
  },
  {
    id: "an-2",
    category: "animals",
    title: "Roaring Lion Guardians",
    description:
      "Majestic pair of white marble lion guardians with flowing manes — regal statement pieces for gates, temples and estates.",
    image:
      "/products/wm-an-2.jpg",
  },
  {
    id: "an-3",
    category: "animals",
    title: "Royal Procession Elephant",
    description:
      "Grand ceremonial elephant with carved howdah cloth, kalash-bearing attendants and tree backdrop — a narrative masterwork in white marble.",
    image:
      "/products/wm-an-3.jpg",
  },
  {
    id: "an-4",
    category: "animals",
    title: "Sandstone Elephant Family",
    description:
      "Heartwarming elephant family — parents with two calves — hand-carved from a single pink sandstone block.",
    image:
      "/products/wm-an-4.jpg",
  },
  {
    id: "an-5",
    category: "animals",
    title: "Trunk-Up Elephant Pair",
    description:
      "Auspicious pair of white marble elephants with raised trunks and carved ceremonial coverings — perfect for entrances and gardens.",
    image:
      "/products/wm-an-5.jpg",
  },
  {
    id: "an-6",
    category: "animals",
    title: "Standing Lion Guardians",
    description:
      "Regal pair of standing lion guardians with finely detailed manes — bold statement pieces for gates and driveways.",
    image:
      "/products/wm-an-6.jpg",
  },
  {
    id: "an-7",
    category: "animals",
    title: "Roaring Simha Pair",
    description:
      "Fierce pair of seated roaring lions in pure white marble — traditional guardians for temples and estates.",
    image:
      "/products/wm-an-7.jpg",
  },
  {
    id: "an-8",
    category: "animals",
    title: "Royal Black Elephant (Gold Painted)",
    description:
      "Majestic black marble elephant with hand-painted gold ornaments, howdah cloth and floral medallions — a royal showpiece for entrances and gardens.",
    image:
      "/products/wm-an-8.jpg",
  },

  // Marble Table Tops (user-supplied)
  {
    id: "tt-1",
    category: "table-top",
    title: "Star Compass Marble Table",
    description:
      "Square white Makrana marble table top with bold black star-compass inlay — a striking modern centrepiece.",
    image:
      "/products/wm-tt-1.jpg",
  },
  {
    id: "tt-2",
    category: "table-top",
    title: "Teal Honeycomb Inlay Table",
    description:
      "Round marble table top with mesmerising teal-and-white honeycomb geometric inlay — vibrant statement piece.",
    image:
      "/products/wm-tt-2.jpg",
  },
  {
    id: "tt-3",
    category: "table-top",
    title: "Mother-of-Pearl Chevron Table",
    description:
      "Round mother-of-pearl radiating table top with a graphic black chevron band — contemporary craftsmanship.",
    image:
      "/products/wm-tt-3.jpg",
  },
  {
    id: "tt-4",
    category: "table-top",
    title: "Concentric Pearl Medallion Table",
    description:
      "Grand round marble table with concentric mother-of-pearl medallions — a bespoke heirloom-grade piece.",
    image:
      "/products/wm-tt-4.jpg",
  },
  {
    id: "tt-5",
    category: "table-top",
    title: "Freeform Grey Pearl Slab",
    description:
      "Freeform organic-shaped marble slab with iridescent grey mother-of-pearl inlay — a sculptural signature table top.",
    image:
      "/products/wm-tt-5.jpg",
  },

  // Jali Work (user-supplied)
  {
    id: "jl-1",
    category: "jali",
    title: "Star & Flower Rosette Jali",
    description:
      "Dense hand-carved jali panel with 6-point stars and floral rosettes — a Mughal-inspired lattice pattern in Makrana white marble.",
    image:
      "/products/wm-jl-1.jpg",
  },
  {
    id: "jl-2",
    category: "jali",
    title: "Floral Marble Jali Panels",
    description:
      "Multiple bespoke floral marble jali panels being carved to order — window screens, partitions and temple wall inserts.",
    image:
      "/products/wm-jl-2.jpg",
  },
  {
    id: "jl-3",
    category: "jali",
    title: "Rajasthani Quatrefoil Sandstone Jali",
    description:
      "Traditional pink sandstone jali with classical Rajasthani quatrefoil (moroccan trellis) pattern — for havelis and heritage-style architecture.",
    image:
      "/products/wm-jl-3.jpg",
  },
  {
    id: "jl-4",
    category: "jali",
    title: "Contemporary Wave Jali Panel",
    description:
      "Modern grey marble jali with cascading curved wave cutouts — a contemporary architectural screen for modern interiors and facades.",
    image:
      "/products/wm-jl-4.jpg",
  },
  {
    id: "jl-5",
    category: "jali",
    title: "Diamond Lattice Marble Jali",
    description:
      "Long white Makrana marble jali strips with classic diamond lattice pattern — ideal for temple balustrades, mandap fronts and railings.",
    image:
      "/products/wm-jl-5.jpg",
  },

  // Modern Art (user-supplied)
  {
    id: "ma-1",
    category: "modern",
    title: "Twin Cranes Marble Sculpture",
    description:
      "Life-sized pair of marble cranes with outstretched wings — a graceful modern art centrepiece for gardens and estates.",
    image:
      "/products/wm-ma-1.jpg",
  },
  {
    id: "ma-2",
    category: "modern",
    title: "Abstract Mother & Child",
    description:
      "Contemporary abstract sculpture of a mother's embrace with a hollow void — a poetic modern art form in Makrana white marble.",
    image:
      "/products/wm-ma-2.jpg",
  },
  {
    id: "ma-3",
    category: "modern",
    title: "Marble Rose Bloom",
    description:
      "Hand-carved cluster of oversized marble roses with intricate petal work — a signature botanical sculpture.",
    image:
      "/products/wm-ma-3.jpg",
  },
  {
    id: "ma-4",
    category: "modern",
    title: "Perseus & Pegasus (Roman Art)",
    description:
      "Roman-inspired composition of a winged warrior beside the rearing Pegasus — a heroic classical sculpture in white marble.",
    image:
      "/products/wm-ma-4.jpg",
  },
  {
    id: "ma-5",
    category: "modern",
    title: "Minimalist Marble Bust",
    description:
      "Serene minimalist bust with softly carved features and a sculpted top-knot — modern portrait art in Makrana marble.",
    image:
      "/products/wm-ma-5.jpg",
  },

  {
    id: "ma-6",
    category: "modern",
    title: "Marble Apple Showpiece",
    description:
      "Glossy Makrana white marble apple with a metal stem — a minimal luxury showpiece for desks, consoles and gallery shelves.",
    image:
      "/products/wm-ma-6.jpg",
  },
  {
    id: "ma-7",
    category: "modern",
    title: "Dreamer on the Cart",
    description:
      "Black marble modern sculpture of a reclining figure resting on a wheeled cart — a thought-provoking statement piece.",
    image:
      "/products/wm-ma-7.jpg",
  },
  {
    id: "ma-8",
    category: "modern",
    title: "Black Swan Sculpture",
    description:
      "Elegant black marble swan with a gracefully curved neck — a striking modern art piece for gardens, foyers and poolsides.",
    image:
      "/products/wm-ma-8.jpg",
  },
  {
    id: "ma-9",
    category: "modern",
    title: "The Gathering (Set of 4)",
    description:
      "Four abstract seated figures in polished black marble — a conversation-piece installation for gardens, lobbies and galleries.",
    image:
      "/products/wm-ma-9.jpg",
  },
  {
    id: "ma-10",
    category: "modern",
    title: "Abstract Wing (Exhibition Piece)",
    description:
      "Sculptural white marble wing showcased at a stone exhibition — sweeping layered curves carved from Makrana marble.",
    image:
      "/products/wm-ma-10.jpg",
  },

  {
    id: "ma-11",
    category: "modern",
    title: "Organic Void Tower",
    description:
      "Tall abstract marble tower with flowing organic voids — a contemporary gallery-grade sculpture carved at our workshop.",
    image:
      "/products/wm-ma-11.jpg",
  },
  {
    id: "ma-12",
    category: "modern",
    title: "Eternal Embrace",
    description:
      "Abstract couple in an eternal embrace with interlocking rings — modern romance sculpted in pure white marble.",
    image:
      "/products/wm-ma-12.jpg",
  },
  {
    id: "ma-13",
    category: "modern",
    title: "Buddha Head Water Feature",
    description:
      "Giant layered sandstone Buddha head with cascading water — a monumental zen centrepiece for gardens, resorts and farmhouses.",
    image:
      "/products/wm-ma-13.jpg",
  },
  {
    id: "ma-14",
    category: "modern",
    title: "Dancing Muse (Exhibition Piece)",
    description:
      "Abstract dancing female figure showcased at a stone exhibition — fluid curves hand-carved in Makrana white marble.",
    image:
      "/products/wm-ma-14.jpg",
  },
  {
    id: "ma-15",
    category: "modern",
    title: "The Musician (Exhibition Piece)",
    description:
      "Abstract figure playing a stringed instrument — a rhythm of curves carved from pure white marble, displayed at exhibition.",
    image:
      "/products/wm-ma-15.jpg",
  },

  // Roman Art & Sculpture (user-supplied)
  {
    id: "rm-1",
    category: "roman",
    title: "Roman Floral Urn",
    description:
      "Classical Roman-style urn with hand-carved floral festoons on a fluted pedestal base — an elegant garden and entrance planter.",
    image:
      "/products/wm-rm-1.jpg",
  },
  {
    id: "rm-2",
    category: "roman",
    title: "Roman Colosseum Carving",
    description:
      "Miniature Colosseum amphitheatre carved from a single block of white marble — three tiers of arches in stunning detail.",
    image:
      "/products/wm-rm-2.jpg",
  },
  {
    id: "rm-3",
    category: "roman",
    title: "Rock-Cut Ruin Facade",
    description:
      "Ancient-ruin style rock-cut facade with carved colonnade and arched gateway emerging from the raw block — museum-style art.",
    image:
      "/products/wm-rm-3.jpg",
  },
  {
    id: "rm-4",
    category: "roman",
    title: "Rock-Hewn Arch Alcove",
    description:
      "Rough-hewn marble block revealing a hidden classical archway with a pillared hall inside — a sculpted illusion of ancient ruins.",
    image:
      "/products/wm-rm-4.jpg",
  },
  {
    id: "rm-5",
    category: "roman",
    title: "Rock-Cut Arcade",
    description:
      "Raw stone block hand-carved to expose a classical arcade of slender columns — a dramatic ruin-art sculpture for collectors.",
    image:
      "/products/wm-rm-5.jpg",
  },
  {
    id: "rm-6",
    category: "roman",
    title: "Gothic Window Rock Carving",
    description:
      "A raw marble block hand-carved to reveal a gothic cathedral window with slender tracery columns and a deep alcove — ruin art at its finest.",
    image:
      "/products/wm-rm-6.jpg",
  },
  {
    id: "rm-7",
    category: "roman",
    title: "Four Seasons Roman Ladies (Set of 4)",
    description:
      "Four classical Greco-Roman maiden statues bearing grapes, wheat and flowers — hand-carved in white marble for gardens, courtyards and villas.",
    image:
      "/products/wm-rm-7.jpg",
  },

  // Makrana Marble Urlis (user-supplied)
  {
    id: "ur-1",
    category: "urli",
    title: "Curled Petal Urli",
    description:
      "Freeform curled-petal urli hand-carved from a single Makrana white marble block — a sculptural pooja water bowl.",
    image:
      "/products/wm-ur-1.jpg",
  },
  {
    id: "ur-2",
    category: "urli",
    title: "Scalloped Petal Urli",
    description:
      "Flat lotus-form urli with delicately scalloped petal edges — an elegant centrepiece for water and flowers.",
    image:
      "/products/wm-ur-2.jpg",
  },
  {
    id: "ur-3",
    category: "urli",
    title: "Lotus Petal Urli with Boss",
    description:
      "Marble lotus urli with radiating pointed petals and a central boss — traditional pooja and decor piece.",
    image:
      "/products/wm-ur-3.jpg",
  },
  {
    id: "ur-4",
    category: "urli",
    title: "Floral Relief Urli (Small)",
    description:
      "Small marble urli with carved flower relief band on the exterior — perfect for altar and desktop displays.",
    image:
      "/products/wm-ur-4.jpg",
  },
  {
    id: "ur-5",
    category: "urli",
    title: "Floral Relief Urli (Large)",
    description:
      "Large Makrana marble urli with sculpted floral band — traditionally filled with water and floating petals for pooja.",
    image:
      "/products/wm-ur-5.jpg",
  },

  // Flower Pots — Marble & Sandstone (user-supplied)
  {
    id: "fp-1",
    category: "flower-pot",
    title: "Grand Petal-Rim Planter Pair",
    description:
      "Large cream sandstone planters with carved petal rims on pedestal bases — majestic entrance and driveway statement pieces.",
    image:
      "/products/wm-fp-1.jpg",
  },
  {
    id: "fp-2",
    category: "flower-pot",
    title: "Tall Veined Marble Vase Pair",
    description:
      "Elegant tall flower vases with natural grey veining — turned from solid marble blocks for luxury foyers and corridors.",
    image:
      "/products/wm-fp-2.jpg",
  },
  {
    id: "fp-3",
    category: "flower-pot",
    title: "Classic Veined Marble Vases",
    description:
      "Timeless amphora-style marble vases with beautiful natural veining — perfect pairs for living rooms and hotel lobbies.",
    image:
      "/products/wm-fp-3.jpg",
  },
  {
    id: "fp-4",
    category: "flower-pot",
    title: "Swirl-Ribbed Marble Pot Pair",
    description:
      "Round white marble pots with swirling ribbed carving and beaded rims — charming planters for balconies and gardens.",
    image:
      "/products/wm-fp-4.jpg",
  },
  {
    id: "fp-5",
    category: "flower-pot",
    title: "Lotus-Leaf Sandstone Pot Pair",
    description:
      "Cream sandstone flower pots with lotus-leaf carved bowls and fluted pedestal bases — classical garden elegance.",
    image:
      "/products/wm-fp-5.jpg",
  },
  {
    id: "fp-6",
    category: "flower-pot",
    title: "Golden Ribbed Sandstone Vases",
    description:
      "Tall golden sandstone vases with bold horizontal ribbing and natural wood-like grain — striking floor pieces for lobbies.",
    image:
      "/products/wm-fp-6.jpg",
  },
  {
    id: "fp-7",
    category: "flower-pot",
    title: "Golden Trumpet Vase Pair",
    description:
      "Graceful trumpet-neck vases in warm golden sandstone with flowing natural grain — timeless pairs for entrances and halls.",
    image:
      "/products/wm-fp-7.jpg",
  },
  {
    id: "fp-8",
    category: "flower-pot",
    title: "Teak-Grain Round Planters",
    description:
      "Round sandstone planters with stunning teak-wood-like natural grain — one smooth, one wave-carved — rustic luxury for gardens.",
    image:
      "/products/wm-fp-8.jpg",
  },
  {
    id: "fp-9",
    category: "flower-pot",
    title: "White Ribbed Vase Pair",
    description:
      "Tall white marble vases with fine horizontal ring turning — clean, contemporary silhouettes for modern interiors.",
    image:
      "/products/wm-fp-9.jpg",
  },
  {
    id: "fp-10",
    category: "flower-pot",
    title: "Blush Marble Pedestal Urn",
    description:
      "Soft blush-white marble urn with a wide flared rim on a turned pedestal base — a romantic centrepiece for tabletops and altars.",
    image:
      "/products/wm-fp-10.jpg",
  },
  {
    id: "fp-11",
    category: "flower-pot",
    title: "Swirl Pot Pair on Square Bases",
    description:
      "White sandstone pots with diagonal swirl carving and scalloped rims on square plinths — crisp geometry for patios and pathways.",
    image:
      "/products/wm-fp-11.jpg",
  },
  {
    id: "fp-12",
    category: "flower-pot",
    title: "Midnight Black Trumpet Vases",
    description:
      "Deep black-green marble trumpet vases with a mirror polish — dramatic contrast pieces for modern luxury interiors.",
    image:
      "/products/wm-fp-12.jpg",
  },
  {
    id: "fp-13",
    category: "flower-pot",
    title: "Tall Tapered Golden Planters",
    description:
      "Sleek tall tapered planters in golden sandstone with natural flowing grain — minimal, elegant and timeless.",
    image:
      "/products/wm-fp-13.jpg",
  },
  {
    id: "fp-14",
    category: "flower-pot",
    title: "Carved Kalash Planter Pair",
    description:
      "Traditional kalash-shaped golden sandstone planters with hand-carved leaf bands and floral medallions — festive and auspicious.",
    image:
      "/products/wm-fp-14.jpg",
  },
  {
    id: "fp-15",
    category: "flower-pot",
    title: "Ivory Trumpet Vase Pair",
    description:
      "Slender ivory sandstone vases with flared rims and graceful baluster bodies — refined pairs for entrances and staircases.",
    image:
      "/products/wm-fp-15.jpg",
  },
  {
    id: "fp-16",
    category: "flower-pot",
    title: "Swan-Base Pedestal Planters (Set of 4)",
    description:
      "Tall Makrana white marble planters with swan-carved pedestal columns and lotus-leaf rims — a grand set for driveways and lawns.",
    image:
      "/products/wm-fp-16.jpg",
  },
  {
    id: "fp-17",
    category: "flower-pot",
    title: "Floral Carved Urn Pair (Makrana White)",
    description:
      "Majestic tall urns in Makrana white marble with all-over floral relief carving and leaf-carved necks — statement pairs for grand entrances.",
    image:
      "/products/wm-fp-17.jpg",
  },

  // Tulsi Vrindavan (user-supplied)
  {
    id: "tv-1",
    category: "tulsi",
    title: "White Ornate Panel Tulsi Vrindavan",
    description:
      "Pure white marble Tulsi Vrindavan with an ornate carved front panel, beaded rims and lattice-cut base — a sacred centrepiece for your aangan.",
    image:
      "/products/wm-tv-1.jpg",
  },
  {
    id: "tv-2",
    category: "tulsi",
    title: "White Scalloped Frieze Tulsi Vrindavan",
    description:
      "Makrana white marble Tulsi Vrindavan with scalloped frieze, floral relief panels and an arched niche — hand-carved temple-style detailing.",
    image:
      "/products/wm-tv-2.jpg",
  },
  {
    id: "tv-3",
    category: "tulsi",
    title: "Midnight Lotus Tulsi Vrindavan",
    description:
      "Dramatic dark-stone Tulsi Vrindavan crowned with a blooming lotus — pillared base with diamond-lattice carving and a mirror-polished finish.",
    image:
      "/products/wm-tv-3.jpg",
  },
  {
    id: "tv-4",
    category: "tulsi",
    title: "Lotus Crown Sandstone Tulsi Vrindavan",
    description:
      "Cream sandstone Tulsi Vrindavan with a grand lotus-bowl crown, petal-moulded base and carved niche — shown installed at a client site.",
    image:
      "/products/wm-tv-4.jpg",
  },
  {
    id: "tv-5",
    category: "tulsi",
    title: "Golden Floral Sandstone Tulsi Vrindavan",
    description:
      "Golden sandstone Tulsi Vrindavan with a deep planter bowl, floral frieze and pierced jali-style panels — traditional Vastu shubh design.",
    image:
      "/products/wm-tv-5.jpg",
  },
  {
    id: "tv-6",
    category: "tulsi",
    title: "Royal Crown Tulsi Vrindavan",
    description:
      "White marble Tulsi Vrindavan with a crenellated crown rim, deep round planter and vine-carved niche panels — a majestic courtyard piece.",
    image:
      "/products/wm-tv-6.jpg",
  },
  {
    id: "tv-7",
    category: "tulsi",
    title: "Four-Sided Floral Tulsi Vrindavan",
    description:
      "Elegant white marble Tulsi Vrindavan carved on all four sides with hanging floral vines and arched niches — beauty from every angle.",
    image:
      "/products/wm-tv-7.jpg",
  },
  {
    id: "tv-8",
    category: "tulsi",
    title: "Compact Mayur Tulsi Vrindavan",
    description:
      "Smaller white marble Tulsi Vrindavan with delicate bird and vine carvings — perfect for balconies, flats and compact pooja corners.",
    image:
      "/products/wm-tv-8.jpg",
  },
  {
    id: "tv-9",
    category: "tulsi",
    title: "Diya Niche Tulsi Vrindavan",
    description:
      "White marble Tulsi Vrindavan with fluted corner columns and a built-in diya bowl in the arched niche — ready for daily aarti.",
    image:
      "/products/wm-tv-9.jpg",
  },
  {
    id: "tv-10",
    category: "tulsi",
    title: "Scalloped Rim Tulsi Vrindavan",
    description:
      "Polished white marble Tulsi Vrindavan with a smooth round bowl top, scalloped rim and ornate toran-arch niche — premium showroom finish.",
    image:
      "/products/wm-tv-10.jpg",
  },
];

export const HIGHLIGHTS = [
  { number: "11+", label: "Years of Craftsmanship" },
  { number: "16", label: "Product Categories" },
  { number: "1000+", label: "Temple Installations" },
  { number: "100+", label: "Countries Exported" },
];

export const MARQUEE_ITEMS = [
  "Crafting Divine Beauty in Marble",
  "Grade 1 Makrana Sangmarmar",
  "Custom Made — Pre-Order",
  "Worldwide Shipping",
  "Since 2014",
  "Handcrafted in India",
];

export const INSTALLATION_VIDEOS = [
  {
    id: "vid-surat-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/t9xipzhp_video_20260831_113050_edit.mp4",
    poster:
      "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/06pmvv36_IMG-20250723-WA0005.jpg",
    title: "Makrana White Marble Temple — Final Fitting",
    location: "Surat, Gujarat",
    client: "Mr. Dinesh Sailor",
  },
  {
    id: "vid-geeta-panel",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/k0b1c20d_VID-20260901-WA0005.mp4",
    poster:
      "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/s9rlkwwx_IMG-20260901-WA0004.jpg",
    title: "Custom Geeta Updesh Wall Panel — 3ft × 4ft",
    location: null,
    client: null,
  },
  {
    id: "vid-virar-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/zuweq7lz_video_20260903_102938_edit.mp4",
    poster: "/posters/virar-fitting.jpg",
    title: "Peacock Jali Marble Temple — Final Fitting",
    location: "Virar, Thane",
    client: null,
  },
  {
    id: "vid-ghatkopar-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/45ln2lze_video_20260903_102856_edit.mp4",
    poster: "/posters/ghatkopar-fitting.jpg",
    title: "Ashtamangal Tree-of-Life Temple — Final Fitting",
    location: "Ghatkopar, Mumbai",
    client: "Mr. Nimesh Shah",
  },
  {
    id: "vid-plano-usa",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/6qtelmro_video_20260903_102817_edit.mp4",
    poster: "/posters/plano-usa.jpg",
    title: "Carved Marble Temple — Exported & Delivered",
    location: "Plano, USA",
    client: "Mr. Gourav Agrawal",
  },
  {
    id: "vid-chembur-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/m3yxjx0e_video_20260903_102616_edit.mp4",
    poster: "/posters/chembur-fitting.jpg",
    title: "Twin-Shikhar Marble Temple — Final Fitting",
    location: "Chembur, Mumbai",
    client: "Mrs. Richa Zaveri",
  },
  {
    id: "vid-rajkot-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/9ftk7zqm_video_20260903_102256_edit.mp4",
    poster: "/posters/rajkot-fitting.jpg",
    title: "Grand Triple-Arch Marble Temple — Final Fitting",
    location: "Rajkot, Gujarat",
    client: "Patel Nut Bolts Service",
  },
  {
    id: "vid-gwalior-1",
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_vardaan-divine/artifacts/y33cj6io_VID_120430820_031457_324.mp4",
    poster: "/posters/gwalior-fitting.jpg",
    title: "Floral Inlay Marble Temple — Final Fitting",
    location: "Gwalior, Madhya Pradesh",
    client: "Mr. Abhishek Rathi",
  },
];
